const InactiveSubscription = require('./InactiveSubscription');

module.exports = InactiveSubscription;
